import { forceUpdate } from '@weblite/persist'
import {
  EVENT_INVALIDATE_USER,
  EVENT_INVALIDATE_USER_STATUS,
  EventInvalidateUserPayload,
  EventInvalidateUserStatusPayload,
} from '@weblite/ts-action/user'
import {
  invalidatedUserStatus,
  usersStatusStorage,
} from './user-status.storage'
import { updateCachedUserPermissionsInPv } from '$logic/user-permissions'
import { serverSub } from '$func/subscription'

serverSub.subscribe(
  EVENT_INVALIDATE_USER,
  (payload: EventInvalidateUserPayload) => {
    forceUpdate('users', [payload.userId])
    updateCachedUserPermissionsInPv(payload.userId)
  },
)

serverSub.subscribe(
  EVENT_INVALIDATE_USER_STATUS,
  (payload: EventInvalidateUserStatusPayload) => {
    usersStatusStorage.del(payload.userId)
    invalidatedUserStatus.add(payload.userId)
  },
)
